module.exports = __webpack_public_path__ + "static/img/cover.4f7962c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/cover.jpg
// module id = iN/y
// module chunks = 0